module.exports = __webpack_public_path__ + "c09b60d4028b1a9b50f97b6f42c8eaaf.svg";